// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/form/attachment-control/attachment-queue-item/attachment-queue-item.scss
// module id = 2044
// module chunks = 50